var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-skeleton',{staticClass:"m-b-20",attrs:{"widht":"100%"}}),_c('b-skeleton',{staticClass:"m-b-20",attrs:{"widht":"100%"}}),_c('b-skeleton',{staticClass:"m-b-20",attrs:{"widht":"100%"}}),_c('b-skeleton',{staticClass:"m-b-20",attrs:{"widht":"100%"}}),_c('b-skeleton',{staticClass:"m-b-20",attrs:{"widht":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }